angular.module('impactx.search').controller('SearchListCatalogPreSetCtrl', SearchListCatalogPreSetCtrl);

SearchListCatalogPreSetCtrl.$inject = ['OneTimeDataTransporter', 'AppConfiguration', 'ToolbarService'];

function SearchListCatalogPreSetCtrl(OneTimeDataTransporter, AppConfiguration, ToolbarService) {
    var self = this;
    self.showResultsAsList = AppConfiguration.get('displayAllResultsAsList');
    self.catalogs = OneTimeDataTransporter.getData();
    self.numberOfCatalogs = self.catalogs.length;
    self.trns = OneTimeDataTransporter.getTrns();

    var buttonDefinition = [];
    ToolbarService.setButtons(buttonDefinition);
}